import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { changeLang, toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { UI_LANGUAGE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import clsx from 'clsx';

import styles from './Languages.module.css';

const Languages = (props) => {
    const handleChangeLanguage = (e, lang) => {
        e.preventDefault();
        if (props.isAuthZone) {
            props.changeLang(lang);
        } else if (props.isRequest) {
            window.location.href = `${getLangCountryPrefix(lang, props.country)}/request`;
            props.toggleSpinner(true);
        } else if (props.isLanding) {
            window.location.href = getLangCountryPrefix(lang, props.country);
            props.toggleSpinner(true);
        } else {
            const regex = /\/([a-z]{2})-([a-z]{2})(\/+.*)/;
            const { pathname } = window.location;
            const result = pathname.match(regex) || [];
            let url;
            if (result.length > 0 && result[3].length > 0) {
                url = result[3];
            } else {
                url = pathname;
            }
            window.location.href = `${getLangCountryPrefix(lang, props.country)}${url}`;
            props.toggleSpinner(true);
        }
        amplitude.getInstance().setUserProperties({ [UI_LANGUAGE]: lang });
        props.toggleModal(false);
    };

    const getDropList = (languages = []) => {
        const availableLanguages = languages.filter((lang) => lang?.localeCode && lang?.name);
        return (
            <ul className={styles.list}>
                {availableLanguages.map((lang) => (
                    <Text key={lang.localeCode} variant="listItem" color="primary">
                        <a
                            id={`lang-${lang.localeCode}`}
                            className={clsx(styles.link, props.lang === lang.localeCode && styles.selected)}
                            href={getLangCountryPrefix(lang.localeCode, props.country)}
                            onClick={(e) => handleChangeLanguage(e, lang.localeCode)}
                        >
                            {lang.name}
                        </a>
                    </Text>
                ))}
            </ul>
        );
    };

    return (
        <ModalComponent isIconClose>
            <HeaderPanel title={props.title} />
            {getDropList(props.languages)}
        </ModalComponent>
    );
};

Languages.propTypes = {
    lang: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            localeCode: PropTypes.string,
            name: PropTypes.string,
        }),
    ),
};

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps, { changeLang, toggleModal, toggleSpinner })(Languages);
